import { render, staticRenderFns } from "./Pos_manage_service.vue?vue&type=template&id=464ba2ea&scoped=true&"
import script from "./Pos_manage_service.vue?vue&type=script&lang=js&"
export * from "./Pos_manage_service.vue?vue&type=script&lang=js&"
import style0 from "./Pos_manage_service.vue?vue&type=style&index=0&id=464ba2ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464ba2ea",
  null
  
)

export default component.exports